import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2 } from "react-icons/fi";
import { FcCheckmark, FcCancel } from "react-icons/fc";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Row, Col, Table } from "react-bootstrap";
import EditModal from "./EditModal";
import ErrorModal from "../../components/ErrorModal";
import HandleHttpErrors from "../../components/HandleHttpErrors";
import { Checkbox } from "@material-ui/core";
import useAuth from "../../hooks/useAuth";

const baseURL = process.env.REACT_APP_API;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  pageNumber,
  setPageNumber,
}) => {
  const [users, setUsers] = useState(null);
  const [userId, setUserId] = useState(null);
  const { auth } = useAuth();
  const [searchUsername, setSearchUsername] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [searchString, setSearchString] = useState("");
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [groups, setGroups] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const [loading, setLoading] = useState(true);
  const [isInactive, setIsInactive] = useState(false);
  const [isManagers, setIsManagers] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getGroups = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "accounts/getgroups/",
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          if (auth?.roles?.includes("SuperAdmin")) {
            setGroups(
              response.data.map((item) => ({
                value: item.name,
                label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
              }))
            );
          } else {
            setGroups([
              {
                value: "moamadeem",
                label: "Moamadeem",
              },
              {
                value: "ReviewMoamadeem",
                label: "ReviewMoamadeem",
              },
            ]);
          }
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getGroups();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    if (pageNumber == null) {
      setPageNumber("1");
    }
    const getUsers = async () => {
      try {
        const response = await axiosPrivate.get(
          `${baseURL}accounts/userslist/?page=${pageNumber || 1}`,
          {
            signal: controller.signal,
          }
        );

        if (isMounted) {
          setIsInactive(false);
          setIsManagers(false);
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getUsers();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);

  const getNextPage = async () => {
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      try {
        const response = await axiosPrivate.get(nextPage, {
          signal: controller.signal,
        });

        if (isMounted) {
          setIsInactive(false);
          setIsManagers(false);
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
          nextPage && setPageNumber(nextPage.split("=")[1]);
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getUsers();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };
  const getPrevPage = async () => {
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      try {
        const response = await axiosPrivate.get(prevPage, {
          signal: controller.signal,
        });

        if (isMounted) {
          setIsInactive(false);
          setIsManagers(false);
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
          prevPage && setPageNumber(prevPage.split("=")[1]);
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getUsers();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const handleEditClick = (event, user) => {
    event.preventDefault();
    setShowEdit(true);
    setUserId(user.id);
  };
  // Handle checkbox state change
  const handleInactiveChange = (event) => {
    event.preventDefault();
    const checked = event.target.checked;
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      try {
        if (checked) {
          setSearchEmail("");
          setSearchUsername("");
        }
        const response = await axiosPrivate.get(
          baseURL + "accounts/userslist/?isinactive=" + checked,
          {
            signal: controller.signal,
          }
        );

        isMounted &&
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    //if (isInactive) {
    getUsers();
    //}

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };
  const handleDisplayManagers = (event) => {
    event.preventDefault();
    const checked = event.target.checked;
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      try {
        if (checked) {
          setSearchEmail("");
          setSearchUsername("");
        }
        const response = await axiosPrivate.get(
          baseURL + "accounts/userslist/?ismanagers=" + checked,
          {
            signal: controller.signal,
          }
        );

        isMounted &&
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    //if (isInactive) {
    getUsers();
    //}

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const handleChangeSearch = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (value !== "") {
      if (name === "searchUsername") {
        setSearchUsername(value);
        setSearchEmail("");
      } else {
        setSearchEmail(value);
        setSearchUsername("");
      }
    } else {
      if (name === "searchUsername") {
        setSearchUsername("");
      } else {
        setSearchEmail("");
      }
    }
    setSearchString(searchUsername + searchEmail);
  };
  const handleSubmitSearch = (event) => {
    let isMounted = true;
    const controller = new AbortController();
    const getUsers = async () => {
      //baseURL + "accounts/userslist/?search=" + searchString
      try {
        if (searchEmail || searchUsername) {
          setIsInactive(false);
          setIsManagers(false);
        }
        const response = await axiosPrivate.get(
          baseURL +
            "accounts/userslist/?email=" +
            searchEmail +
            "&username=" +
            searchUsername,
          {
            signal: controller.signal,
          }
        );

        isMounted &&
          setUsers(
            response.data.results.sort((a, b) => (a.id < b.id ? 1 : -1))
          );
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getUsers();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };
  if (!users) return null;
  return (
    <>
      <div className="mx-auto">
        <form>
          <label htmlFor="full_name">
            <center>
              {" "}
              <h2>ניהול משתמשים</h2>
            </center>
          </label>
          <table className="table">
            <tbody>
              <tr>
                <td className="padding-td">
                  <label htmlFor="searchUsername">שם המשתמש</label>
                  <input
                    type="text"
                    name="searchUsername"
                    className="form-control equal-width-input"
                    id="searchUsername"
                    value={searchUsername}
                    placeholder=""
                    onChange={handleChangeSearch}
                  />
                </td>

                <td className="padding-td">
                  <label htmlFor="searchEmail">דואר אלקטרוני</label>
                  <input
                    type="email"
                    name="searchEmail"
                    className="form-control equal-width-input"
                    id="searchEmail"
                    value={searchEmail}
                    placeholder=""
                    onChange={handleChangeSearch}
                  />
                </td>

                <td className="padding-td">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmitSearch}
                  >
                    חיפוש
                  </button>
                </td>
              </tr>
              <tr>
                <td className="padding-td">
                  <Checkbox
                    checked={isInactive}
                    onChange={(event) => {
                      setIsManagers(false);
                      setIsInactive(!isInactive);
                      handleInactiveChange(event);
                    }}
                  />{" "}
                  סנן משתמשים בלתי פעילים
                </td>
                <td className="padding-td">
                  <Checkbox
                    checked={isManagers}
                    onChange={(event) => {
                      setIsInactive(false);
                      setIsManagers(!isManagers);
                      handleDisplayManagers(event);
                    }}
                  />{" "}
                  הצג מנהלים
                </td>
                <td className="padding-td"></td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th>שם משתמש</th>
                    <th>כתובת דואר אלקטרוני</th>
                    <th>קבוצות</th>
                    <th>פעיל</th>
                    <th style={{ textAlign: "center", direction: "rtl" }}>
                      כלים
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {users?.map((user) => (
                    <Fragment key={user?.id}>
                      {userId === user?.id ? (
                        <EditModal
                          showEdit={showEdit}
                          setShowEdit={setShowEdit}
                          user={user}
                          increment={increment}
                          optionList={groups}
                          setUserId={setUserId}
                          counter={counter}
                        />
                      ) : (
                        <ReadOnlyRows
                          user={user}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setUserId={setUserId}
                          pageNumber={pageNumber}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
        <center>
          <Row>
            <Col>
              <button
                id="changePage"
                className="btn btn-warning"
                onClick={getPrevPage}
                disabled={prevPage === null}
              >
                הקודם
              </button>
            </Col>
            <Col>
              <button
                id="changePage"
                className="btn btn-warning"
                onClick={getNextPage}
                disabled={nextPage === null}
              >
                הבא
              </button>
            </Col>
          </Row>
        </center>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  user,
  handleEditClick,
  handleChangePass,
  setUserId,
  increment,
  pageNumber,
}) => {
  const axiosPrivate = useAxiosPrivate("application/json");

  // Hide the modal

  const handleActions = (e, user, action) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "accounts/updateuser/" + user.id + "/",
          { action: action },
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            alert("אינך מורשה לבצע פעולה זו או כתובת מייל בשימוש משתמש אחר!");
          }
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setUserId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <>
      <tr>
        <td>{user?.username}</td>
        <td>{user?.email}</td>
        <td>{user?.groups?.map((obj) => obj.name).join(", ")}</td>
        <td>{user?.is_active ? "כן" : "לא"}</td>
        <td style={{ textAlign: "left", direction: "rtl" }}>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-danger space-button"
              onClick={(event) => handleEditClick(event, user)}
            >
              <FiEdit2 />
            </button>

            <button
              type="button"
              className="btn btn-light space-button"
              disabled={!user?.is_active}
              onClick={(event) => handleActions(event, user, "suspend")}
            >
              <FcCancel />
            </button>
            <button
              type="button"
              className="btn btn-light space-button"
              disabled={user?.is_active}
              onClick={(event) => handleActions(event, user, "activate")}
            >
              <FcCheckmark />
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};
